import { environment } from '../../environments/environment';
export { environment } from '../../environments/environment';
export function GetReportingApiUrl(path, params) {
    var reportingPrefix = environment.microserviceApiReporting;
    var url = environment.apiHost + reportingPrefix + path;
    if (params instanceof Object) {
        url += '?';
        Object.entries(params).forEach(function (_a) {
            var param = _a[0], value = _a[1];
            url += encodeURIComponent(param) + "=" + encodeURIComponent(value) + "&";
        });
    }
    return url;
}
